module.exports = {
  system: {
    changeLocale: '切换语言',
    create: '新增',
    import: '导入',
    delete: '删除',
    edit: '编辑',
    detail: '详情',
    index: '序号',
    operation: '操作',
    search: '查询',
    reset: '重置',
    confirm: '确定',
    save: '保存',
    cancel: '取消',
    export: '导出',
    back: '返回',
    pleaseInput: '请输入{0}',
    pleaseSelect: '请选择{0}',
    success: '成功',
    fail: '失败',
    continue: '是否继续',
    enable: '启用',
    disable: '禁用',
    emptySelection: '请选择一条记录',
    option: '标签选项',
    closeOthers: '关闭其他',
    closeAll: '关闭所有',
    or: '或',
    hour: '小时',
    minuate: '分钟',
    second: '秒',
    yes: '是',
    no: '否',
    hello: '您好：{0}',
    enter: '打开系统',
    clip2copy: "点击复制",
    copySuccess: "内容已复制到剪切板",
    copyError: "复制失败"
  },
  myValidate: {
    login: [
      '请输入正确的手机号码'
    ],
    register: [
      '请输入正确的手机号码'
    ],
    my: [
      '请输入正确的手机号码',
      '请输入正确的邮件地址',
      '请输入正确的身份证号码',
      '两次输入的密码不一致'
    ]
  },
  menu: {
    home: '首页',
    product: '产品服务',
    service: '服务中心',
    about: '关于我们',
    order: '订单',
    bill: '账单',
    createOrder: '下单',
    my: '我的',
    customs: "关务",
    dashboard: "首页",
    booking: "订舱",
    mawb: "主单",
    trust: "客户托单",
    label: "合规",
    mawbOpt: "操作主单",
    databoard: "看板",
    coa: "美国清关",
    hts: "HTS&Description",
    tariff: "税金",
    mid: "Mid Modify"
  },

  product: {
    ship: {
      title: '海运',
      products: ['中美海运专线', '中美海运拼箱', '海外仓']
    },
    plane: {
      title: '空运',
      products: ['中美空运专线', '中欧空运专线']
    },
    truck: {
      title: '陆运',
      products: ['中欧卡运专线']
    },
    railway: {
      title: '铁运',
      products: []
    },

    description: '服务简介',
    info: '产品概况',
    title: '产品概况',
    goodsType: '货物类型',
    effectTime: '参考时效',
    unitWeight: '单价包裹限重',
    unitVolume: '单件包裹尺寸',
    mode: '计费模式',
    country: '服务国家',
    weightLimit: '重量限制',
    require: '申报要求',
    clearance: '报关服务',
    retunParts: '退件服务',
    intercept: '拦件服务',
    advantage: '产品优势',
    props: '走货属性',
    compensate: '赔偿标准',
    cutOff: '赔偿受理截止时间',
    standard: '索赔标准',
    exemption: '免责情况',
    returnBack: '退仓服务'
  },

  validate: {
    pwdLength: '请输入6-20位密码',
    pwdReg: '密码只能包含字母或数字',
    pwdNotSame: '两次输入的密码不一致'
  },
  login: {
    title: '登录',
    mobile: '手机号码',
    vcode: '验证码',
    getVCode: '获取验证码',

    login: '登录',
    logout: '退出登录',
    loginSuccess: '登录成功',
    logoutSuccess: '退出登录成功',
    noAuth: '权限不足，请联系管理员',

    loginType: ['手机号登录', '帐号登录'],
    account: '帐号',
    password: '密码'

  },
  register: {
    title: '注册',
    userName: '您的姓名',
    companyName: '公司名称',
    mobile: '手机号码',
    vcode: '验证码',
    getVCode: '获取验证码',
    register: '创建用户',
    registerSuccess: '注册成功'
  },
  search: {
    title: '货件查询',
    tips: '请输入单号',
    number: '查询单号',
    orderNumber: '订单号',
    route: '产品渠道',
    destination: '目的地',
    transportType: '运输方式',
    billWeight: '计费重',
    volume: '体积',
    quantity: '件数',
    status: '当前状态',
    type: [
      "订单号",
      "客户参考号",
      "空运主单号",
      "海运业务号"
    ],
    transportTypes: {
      2: "空运",
      3: "海运"
    },
    mawbNumber: "主单号",
    fbaNumber: "分单号",
    wtNo: "委托号",
    org: "始发港",
    dest: "目的港",
    launchDate: "航班日期",
    launchNo: "航班号",
    grossWeight: "毛重"

  },
  calc: {
    title: '运费试算',
    title2: "运价咨询",
    start: '原寄件地区',
    startTip: '请输入原寄件地址，例如：上海市',
    end: '目的地国家',
    endTip: '请输入目的地国家，例如：美国',
    productName: '产品名称',
    productNameTip: '请输入产品名称，例如：美国海派FBA',
    packageType: '包裹类型',
    normalPackage: '普货',
    electrifiedPackage: '带电',
    packageWeight: '包裹重量',
    packageVolume: '包裹体积',
    searchResult: '查询结果：',
    resultTips: '（注：产品计费以实际下单为准，列表内展示的仅供参考）',
    table: [
      '产品名称',
      '目的国家',
      '运输方式',
      '包裹类型',
      '预计时效',
      '体积M³',
      '计泡系数',
      '体积重KG',
      '毛重KG',
      '计费重KG',
      '运费RMB',
      '其他杂费',
      '总运费RMB'
    ],
    createOrder: '下单'
  },

  status: [
    '已签收',
    '',
    '',
    '',
    '已交派',
    '',
    '',
    '',
    '',
    '',
    '',
    '已到达',
    '已起航',
    '',
    '',
    '已入集货仓',
    '',
    '',
    '已下单'
  ],
  bill: {
    title: '账单明细',
    account: '账户金额',
    bond: '保证金金额',
    quota: '额度金额',
    available: '可用金额',
    history: '历史账单',
    unpaid: '未付账单',
    requireInvoice: '申请发票',
    detail: '详情',
    downloadPdf: '下载PDF',
    downloadExcel: '下载Excel',
    excelFileName: '账单费用详情导出',
    pdfFileName: '账单费用详情导出',
    header: [
      '账单号',
      '客户名',
      '订单号',
      '账单日期',
      '付款日期',
      '账单金额(元)',
      '已付金额(元)',
      '未付金额(元)',
      '收款公司',
      '操作',
      '序号'
    ],
    detailDialog: {
      title: '账单详情',
      index: '序号',
      orderNumber: '订单编号',
      refNo: "客户参考号",
      feeDate: '费用日期',
      unitName: '计费单位',
      billingWeight: '计费重(KG)',
      quantity: '数量',
      unitFee: '单价',
      feeType: '费用名称',
      orderFee: '订单金额(元)',
      route: '产品名称',
      transferNo: '转单号',
      currency: "币种",
      rate: "汇率",
      baseAmount: "本位币金额"
    },
    pdf: [
      '账单编号',
      '服务单位',
      '记账周期',
      '结算账单',
      '共<span>{0}</span>个记录， 总计<span>{1}</span>元（含税）',
      '请于{0}前完成付款',
      '收款公司',
      '开户行',
      '账号',
      '备注'
    ],
    invoiceDialog: {
      requireInvoice: '申请开票',
      historyInvoice: '历史开票',
      requestDate: '申请日期',
      invoiceStatus: '发票状态',
      invoiceType: '发票类型',
      table: [
        '账单号',
        '开票类型',
        '账单日期',
        '账单金额',
        '发票抬头',
        '发票类型',
        '开票税点',
        '实际开票金额',
        '申请人',
        '申请时间'
      ]
    }
  },
  my: {
    title: '我的',
    account: '帐号信息',
    business: '业务信息',
    baseInfo: {
      title: '基本信息',
      type: '客户类型',
      name: '客户名称',
      code: '客户编号',
      legalName: '法人姓名',
      legalId: '法人身份证',
      status: '账户状态',
      admin: '管理员用户名',
      adminMobile: '管理员手机号',
      adminEmail: '管理员电子邮箱',
      active: '已生效',
      inactive: '已失效',
      updateSuccess: '基本信息修改成功'
    },
    contacts: {
      title: '客户联系人',
      name: '姓名',
      mobile: '手机号',
      role: '角色',
      mail: '邮箱',
      dataAuth: '数据权限',
      enable: '是否启用',
      orgAuth: '本机构数据',
      userAuth: '个人创建数据',
      create: '新增联系人',
      createSuccess: '新增联系人成功',
      update: '编辑联系人',
      updateSuccess: '编辑联系人成功',
      password: '密码',
      passwordConfirm: '确认密码',
      resetPassword: '重置密码'
    },
    payments: {
      title: '客户付款信息',
      number: '银行卡号/平台账户',
      account: '账户名',
      name: '银行名称/平台名称',
      method: '支付方式',
      type: '付款类型',
      remark: '备注',
      bank: '网银',
      alipay: '支付宝',
      wechat: '微信',
      orgPay: '企业付款',
      personalPay: '个人付款',
      create: '新增付款账户',
      createSuccess: '新增付款账户成功',
      update: '编辑付款账户',
      updateSuccess: '编辑付款账户成功'
    },
    receivable: {
      title: '我司收款账户信息',
      name: '账户名',
      bank: '开户行',
      account: '账户',
      alipayName: '支付宝账户名',
      alipayAccount: '支付宝账户号',
      wechatName: '微信商户名',
      wechatReceiveImage: '微信收款码'
    },
    bank: '银行收款账户信息',
    alipay: '支付宝收款账户信息',
    wepay: '微信收款账户信息',
    addressInfo: {
      title: '地址信息',
      country: '国家',
      address: '地址',
      phone: '电话',
      contact: '联系人',
      type: '类型',
      remark: '备注',
      orgAuth: '本机构数据',
      userAuth: '个人创建数据',
      create: '新增商品信息',
      createSuccess: '新增商品信息成功',
      update: '编辑商品信息',
      updateSuccess: '编辑商品信息成功'
    },
    taxInfo: {
      title: '税务信息',
      ZN: '中国税务信息',
      EU: '欧洲税务信息',
      US: '美国税务信息',
      type: '客户类型',
      address: '单位地址',
      phone: '电话',
      duty: '税号',
      bank: '开户行',
      bankAccount: '银行账户',
      vatNo: 'VAT号',
      eori: 'EORI号',
      ioss: 'IOSS号',
      ein: 'EIN号',
      //
      name: '客户名称',
      code: '客户编号',
      legalName: '法人姓名',
      legalId: '法人身份证',
      status: '账户状态',
      admin: '管理员用户名',
      adminMobile: '管理员手机号',
      adminEmail: '管理员电子邮箱',
      active: '已生效',
      inactive: '已失效',
      updateSuccess: '基本信息修改成功'
    },
    goodsInfo: {
      title: '商品信息',
      nameCn: '中文名',
      nameEn: '英文名',
      hscode: 'HSCODE',
      brand: '品牌',
      model: '型号',
      material: '材质',
      currency: '币种',
      purpose: '用途',
      diffPrice: '差价',
      create: '新增商品信息',
      createSuccess: '新增商品信息成功',
      update: '编辑商品信息',
      updateSuccess: '编辑商品信息成功',
      orgAuth: '本机构数据',
      userAuth: '个人创建数据',
    },
    cartonsInfo: {
      title: '纸箱信息',
      cartonRule: '箱规',
      long: '长CM',
      wide: '宽CM',
      high: '高CM',
      orgAuth: '本机构数据',
      userAuth: '个人创建数据',
      create: '新增纸箱信息',
      createSuccess: '新增纸箱信息成功',
      update: '编辑纸箱信息',
      updateSuccess: '编辑纸箱信息成功'
    }
  },
  about: {
    SeeMore: '查看更多',
    contactUs: '联系我们'
  },
  order: {
    placeOrder: '下单',
    query: '检索',
    form: {
      orderNo: {
        placeholder: '订单号/客户单号/转单号'
      },
      createTime: {
        placeholder: ['下单开始日期', '下单结束日期']
      }
    },
    search: '查询',
    historicalOrders: '历史订单',
    workingOrders: '进行中的订单',
    edit: '编辑',
    print: '打印',
    printDialogTitle: "打印预览",
    cancel: '取消',
    submit: '确认',
    orderNumber: '订单号',
    status: "最新状态",
    statusDate: "最新状态日期",
    orderTime: '下单时间',
    eta: '预计到达时间',
    referenceNumber: '客户参考号',
    trackingNo: '转单号',
    isCustoms: "是否报关",
    actualPksNum: '件数',
    actualVolume: '体积',
    chargingWeight: '计费重KG',
    channelName: '产品渠道',
    destinationCountry: '目的国',
    fbaNo: "FBA号",
    operation: '操作',

    placeOrderDialog: {
      title: '导入订单',
      steps: ['上传EXCEL', '数据预览', '导入数据'],
      uploadBtn: '上传订单表',
      downloadBtn: '点击下载模板',
      errorMsg: '提示信息:',
      next: '下一步',
      prev: '上一步',
      done: '完成',
      onlyXlsx: "仅支持xlsx格式"
    }
  },

  orderDetail: {
    image: "产品图片",
    orderNumber: '订单号',
    createDate: '下单时间',
    eta: '预计到达时间',
    refNo: '客户参考号',
    transferNo: '转单号',
    route: '产品渠道',
    status: '当前状态',
    fbaNo: "FBA",
    destination: '目的国',
    transportType: '运输方式',
    detail: '货物详情',
    quantity: '件数',
    grossWeight: '毛重KG',
    volume: '体积',
    billingWeight: '计费重',
    isSelfClearance: '是否独立报关',
    uploadClearanceFile: '上传报关文件',
    uploaded: "已上传",
    downloadReleaseFile: '下载放行书',
    sender: '发件人',
    senderCompany: '发件人公司',
    senderAddress: '发件人地址',

    consignee: '收件人',
    consigneeCompany: '收件人公司',
    consigneeAddress: '收件人地址',

    notifier: '通知人',
    notifierCompany: '通知人公司',
    notifierAddress: '通知人地址',

    company: '公司',
    address: '地址',

    postCode: '邮编',
    tel: '电话',
    fax: '传真',
    email: '邮箱',
    goodsInfo: '商品信息',
    goodsTable: [
      'OMS中文品名',
      '英文品名',
      'OMS中国HScode',
      '目的国HScode',
      '品牌',
      '型号',
      '材质',
      '用途',
      '特殊属性',
      '申报总数量',
      // '数量每箱',
      '单价（USD）',
      '总价（USD）',
      // '产品毛重KG',
      // '产品净重KG',
      // '箱长CM',
      // '箱宽CM',
      '操作'
    ],
    filesTable: [
      "文件名",
      "上传日期",
      "上传人",
      "操作",
      "文件类型"
    ],
    cancelConfirm: '确认取消?',
    uploadImage: '上传图片',
    previewImage: '图片预览'

  },

  dashboard: {
    left: {
      order: "订单",
      detail: "查看详情",
      createOrder: "下单",
      notUpdateYet: "暂未更新",
    },
    right: {
      error: "异常",
      detail: "查看详情",
      infoError: "信息补全",
      statusError: "状态异常",
      customerService: "联系客服",
      saleService: "联系销售"
    },
    statusList: [
      "已下单",
      "已入集货仓",
      "已出集货仓",
      "出口已放行",
      "已起航",
      "已到港",
      "清关中",
      "已交派",
      "已签收",
    ],
    transportType: {
      1: "空运",
      2: "海运",
      3: "卡运",
      4: "铁运",
      "null": "未知"
    }
  },

  sheet: {
    currentStatus: "当前状态",
    orderNumber: "订单号",
    handler: "处理人",
    createDate: "下单时间",
    communicateRecord: "沟通记录",
    description: "问题描述",
    comment: "发表评论...",
    commentZone: "评论区",
    reply: "回复",
    submit: "提交",
    cancel: "取消",
    send: "发送",
    saySomething: "来说几句把..."
  },

  404: {
    tip: '您所访问的页面不存在',
    backToHome: '返回首页',
    backToPre: '返回上一页'
  },
  403: {
    tip: '您没有权限访问该页面哦',
    backToHome: '返回首页',
    backToPre: '返回上一页'
  },
  customs: {
    waybillNumber: "运单号",
    wplaceholder: "输入运单号搜索",
    referenceNo: "客户单号",
    customsNo: "报关单号",
    customsNo2: "运单号",
    orderDate: "订单日期",
    customsDate: "报关日期",
    status: "状态",
    quantity: "件数",
    volume: "体积",
    packages: "包裹数",
    grossWeight: "毛重",
    currency: "货值币种",
    totalAmount: "货值总价",
    tariff: "关税（元）",
    vat: "增值税（元）",
    totalTax: "税额总价（元）",
    download: "文件下载",
    deliveryTable: [
      "渠道",
      "件数",
      "时间"
    ],
    filesTable: [
      "单证类型",
      "文件名",
      "预览",
      "下载"
    ],
    statusList: [
      "提交单证",
      "清关中",
      "待缴税",
      "已缴税",
      "已放行",
      "已交派",
      "已签收"
    ],
    statusList2: [
      "航班起飞",
      "航班到达",
      "提交单证",
      "清关中",
      "待缴税",
      "已缴税",
      "已放行",
      "已入库",
      "已出库",
      "已交派",
      "已签收"
    ],
    businessType: {
      0: "",
      1: "欧洲空派专线",
      2: "保税区仓库出货",
      3: "海运出口全程",
      4: "空运进口报关",
      5: "空运出口全程",
      6: "一线进境报关",
      7: "空运包机散货",
      8: "海运普货进口",
      9: "海运普货出口",
      14: "APPLE",
      15: "陆运",
      16: "包机",
      17: "7501清关",
      "null": ""

    },
    // [
    //   "",
    //   "跨境出口",
    //   "海运进口",
    //   "海运出口",
    //   "空运进口",
    //   "空运出口",
    //   "保税区"
    // ],
    abnormalTitle: "异常详情",
    abnormalList: [
      "查验",
      "商检",
      "单证",
      "退关",
      "熏蒸",
      "发票单证",
      "装箱单收据",
      "采样"
    ],
    bizTypes: {
      1: "报关文件",
      2: "其他文件",
      8: "放行单",
      10: "运单",
      11: "缴税单"
    }



  },
  booking: {
    submit: "提交",
    add: "添加货物信息",
    createSuccess: "订舱成功",
    typeDeclaration: "报关文件",
    typeClearance: "清关文件",
    title: "订舱",
    limit: "已超仓位载重上限，无法订舱",
    dateType: "航班日期",
    goodsDetail: "订舱信息*",
    mawbNo: "主单号",
    product: "产品",
    length: "长",
    width: "宽",
    height: "高",
    qty: "件数",


    quantity: "件数",
    grossWeight: "毛重",
    volume: "体积",
    billingWeight: "计费重",
    wmsQuantity: "制单件数",
    wmsGrossWeight: "制单毛重",
    wmsVolume: "制单体积",
    wmsBillingWeight: "制单计费重",
    fba: "唛头",
    goodsName: "货物品名",

    cargoSize: "货物尺寸",
    hawbInfo: "分单信息",
    hawbTable: {
      hawbNo: "分单号",
      shipBill: "虚拟分单号",
      sealNo: "虚拟分单标识",
      bookingPkgsNum: "件数",
      bookingGrossWeight: "毛重",
      bookingVolume: "体积",
      customsType: "报关方式"
    },
    cm: "厘米",
    inch: "英寸",
    sft: "制单信息*",
    senderInfo: "付货人及地址",
    senderName: "付货人",
    senderTel: "付货人联系方式",
    senderAddress: "付货人地址",
    consigneeInfo: "收件人及地址",
    consigneeName: "收货人",
    consigneeTel: "收货人联系方式",
    consigneeAddress: "收货人地址",
    notifyInfo: "通知人",
    alsoNotify: "第二通知人",
    bookingReq: "到货信息*",
    bookingReq2: "订舱要求",
    zdfd: "直单/分单",
    paymentType: "运费/杂费条款",
    billType: "结费方式",
    salesCompany: "销售公司",
    reserveFlightnr: "预定航班",
    flightnrDate: "航班日期",
    positionReq: "仓位要求",
    specialApply: "申请特价",
    remark: "备注",
    valueAddedServices: "海关信息*",
    customsDeclaration: "出口报关",
    declarationFiles: "报关文件",
    customsClearance: "进口清关",
    clearanceFiles: "清关文件",
    pickUpService: "是否提货",
    warehouseCode: "收货仓库",
    pickUpAddress: "取件地址",

    transfer: "目的地转运",
    transferAddress: "转运地址",
    transferPhone: "联系方式",
    deadline: "截单",
    book: "订",
    bookInfoError: "无法获取航班信息",
    waybillTypeOptions: ["直单", "分单"],
    paymentTypeOptions: ["预付", "到付"],
    billTypeOptions: ["信用证", "电汇", "承兑交单", "付款交单", "赊销"],
    // positionRequireOptions: ["Must go", "Stand by", "Normal"],
    positionRequireOptions: {
      0: "Must go",
      1: "Stand by",
      2: "Normal",
      "-1": "Normal",
      "null": "Normal"
    },
    radioOptions: ["否", "是"],
    pickupServiceOptions: ["送前置仓", "我司提货", "自送机场"],
    upload: "上传",
    address: {
      YNT: "烟台",
      TNA: "济南",
      TSN: "天津",
      NKG: "南京",
      PEK: "北京",
      PVG: "上海",
      KNH: "南昌",
      WUH: "武汉",
      XIY: "西安",
      DLC: "大连",
      CSX: "长沙",
      HRB: "哈尔滨",
      CKG: "重庆",
      CTU: "成都",
      CAN: "广州",
    },
    itemTable: [
      "商品编码",
      "中文品名",
      "数量",
      "公斤数"
    ]
  },
  mawb: {
    funcError: "页面异常",
    oidError: "主单信息异常",
    updateSuccess: "更新成功",
    flightDate: "航班日期",
    mawbOrFlightNo: "主单号或航班号",
    export: "导出",
    table: [
      "主单状态",
      "航司提单",
      "航班号",
      "航班日期",
      "起飞日期",
      "到达日期",
      "目的港",
      "件数",
      "毛重KG",
      "体积CBM",
      "计费重",
      "备注"

    ],
    status: {
      0: "已拒绝",
      29: "待订舱",
      30: "已拒绝",
      31: "已订舱",
      32: "已入仓",
      3: "已起航",
      4: "已到达",
      33: "已配齐",
      34: "已通知提货",
      8: "已提货",
      42: "制单",
      41: "货站收货",
      40: "开始拆板",
      44: "主单审单",
      43: "客户确认",
      45: "磅单上传"
    },
    print: "打印",
    exportPdf: "导出PDF"



  },
  databoard: {
    flightnr: "航班号",
    etd: "航班日期",
    pol: "始发港",
    pod: "目的港",
    mawbNumber: "主单数",
    grossWeight: "毛重",
    volume: "体积",
    thisBillingWeight: "本期航班计费重",
    lastBillingWeight: "上期航班计费重",
    takeOff: "距离起飞",
    takeOffed: "已起飞",
    waitingForApproval: "待审单",
    waitingForWarehousing: "待入仓",
    toBePrepared: "待制单",
    customerConfirmation: "待客户确认",
    transmissionOfCustomsDeclarationData: "待传报关资料",
    toBeReleased: "待放行",
    status: "状态",
    completeRate: "完成率",
    thisFlightnrWarehousing: "本航班入仓情况",
    nextFlighnrBooking: "下个航班订舱情况",
    bookingGw: "订舱毛重",
    bookingVol: "订舱体积",
    rebubbleRatio: "重泡比",
    lastFlightPlate: "上个航班拆板情况",
    mawb: "主单数",
    plate: "打板数",
    uldIn: "入仓",
    startBreakdown: "开始理货",
    tallyFinished: "理货完成",
    outbound: "已提货",
    customerGW: "客户入仓数据-毛重KG"




  },

  label: {
    orderNo: "订单号",
    createDate: "创建日期",
    pick: "挑款",
    pickSuccess: "挑款成功",
    pickTypeOpt: ["未挑款", "款号&色号", "款号"],
    verificationStatusOpt: ["未拍照", "拍照中", "已拍照", "已合规"],
    labelStatusOpt: [
      "已导入",
      "处理中",
      "处理完成",
      "拍照中",
      "已拍照",
      "合规中",
      "已合规",
      "已完成",
    ],
    pickListBtn: "打印挑款单",
    styleCount: "款号数",
    status: "状态",
    cargoInfo: "商品信息",
    table: [
      "款号",
      "色号",
      "品名",
      "成分",
      "单价",
      "状态",
      "照片",
      "反馈"
    ],
    pickListTable: [
      "箱号",
      "款号",
      "颜色",
      "产地",
      "数量",
      "挑款单",
      "备注",
      "总箱数",
      "总挑款数"
    ],
    import: {
      title: "导入订单",
      scheme: "导入方案",
      brand: "品牌",
      invoiceFile: "主类型文件(invoice,packinglist等)",
      masterFile: "辅助1文件(master file,price等)",
      otherFIle: "辅助2文件(master file,price等)",
      uploadBtn: "上传文件",
      hint: "提示信息"
    },
    detailDialog: {
      title: "反馈详情",
      barcode: "条码",
      style: "款号",
      color: "色号",
      size: "尺寸",
      season: "季节",
      desc: "品名",
      composition: "成分",
      question: "问题",
      response: "答复",
      image: "照片"
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/languages/zh-cn.js